<template>
  <div id="dcf-app">
    <main-fflguard></main-fflguard>
  </div>
</template>

<script>
import MainFflguard from './components/MainFflguard.vue';
export default {
  name: 'app',
  data () {
    return {
    }
  }
}
</script>

<style>
/*#dcf-app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/

/*h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue